import { useFiltersApi } from '@/hooks'
import { ActiveManagementFiltersValues } from '@/utils/constants'
import { useMemo } from 'react'
import { useActiveManagementFiltersGetParams } from './useActiveManagementFiltersGetParams'

type Props = {
    activeFilters: ActiveManagementFiltersValues
}

export const useActiveManagementMetersQuery = ({ activeFilters }: Props) => {
    const { useMetersQuery } = useFiltersApi()
    const params = useActiveManagementFiltersGetParams(activeFilters)

    const metersQueryParams = useMemo(
        () => ({
            'nodeIds[]': params['nodeIds[]'],
            'tagIds[]': params['tagIds[]'],
            'facilityIds[]': params['facilityIds[]'],
            'usnAccountIds[]': params['usnAccountIds[]'],
            reportType: 'interval',
        }),
        [params]
    )

    return useMetersQuery(metersQueryParams)
}
